import * as React from 'react';
import type { SVGProps } from 'react';
const SvgColumns2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.75 19.25h.5a1 1 0 0 0 1-1V5.75a1 1 0 0 0-1-1h-.5a1 1 0 0 0-1 1v12.5a1 1 0 0 0 1 1M11.75 19.25h.5a1 1 0 0 0 1-1V5.75a1 1 0 0 0-1-1h-.5a1 1 0 0 0-1 1v12.5a1 1 0 0 0 1 1M17.75 19.25h.5a1 1 0 0 0 1-1V5.75a1 1 0 0 0-1-1h-.5a1 1 0 0 0-1 1v12.5a1 1 0 0 0 1 1"
    />
  </svg>
);
export default SvgColumns2;
